import React from "react";
import HomepageHeading from "../../components/HomepageHeading";
import i18n from "~/assets/js/Helpers/i18n";
import MarkdownText from "~/assets/js/components/Typography/MarkdownText";
import Headline from "~/assets/js/components/Typography/Headline";
import PropTypes from "prop-types";

const USPs = () => {
    const { usps } = reactConfig;

    if (!usps.length) {
        return null;
    }

    return (
        <div className="homepage-usps">
            <HomepageHeading
                metaTitle={i18n.t("home.usps.metaTitle")}
                title={i18n.t("home.usps.title")}
            />
            <div className="homepage-usps_card_container">
                {usps.map((usp) => {
                    return (
                        <USP
                            key={usp.title}
                            logoUrl={usp.usp_logo}
                            title={usp.title}
                            content={usp.content}
                        />
                    );
                })}
            </div>
        </div>
    );
};

const USP = ({ logoUrl, title, content }) => {
    return (
        <div className="homepage-usps_card">
            <img
                className="homepage-usps_card_image"
                src={logoUrl}
                alt={`usp-image-${title}`}
            />
            <div className="homepage-usps_card_content_container">
                <Headline size={6} className="title">
                    {title}
                </Headline>
                <MarkdownText className="homepage-usps_card_content">
                    {content}
                </MarkdownText>
            </div>
        </div>
    );
};

USP.propTypes = {
    logoUrl: PropTypes.string,
    title: PropTypes.string,
    content: PropTypes.string,
};

export default USPs;
